import axios from '@/libs/api.request'

// 查询拣货员sku
export const querySortingSku = (data) => {
	return axios.request({
		url: '/api/v1/sorting/querySortingSku',
		params: data,
		method: 'get',
	})
};

// 查询sku拣货数据
export const querySortingBySku = (data) => {
	return axios.request({
		url: '/api/v1/sorting/querySortingBySku',
		params: data,
		method: 'get',
	})
};

// 查询线路
export const queryCarLine = (data) => {
	return axios.request({
		url: '/api/v1/sorting/queryCarLine',
		params: data,
		method: 'get',
	})
};

// 非标品拣货
export const editSorting = (data) => {
	return axios.request({
		url: '/api/v1/sorting/editSorting',
		data,
		method: 'post',
	})
};

// 标品拣货
export const editSortingStandard = (data) => {
	return axios.request({
		url: '/api/v1/sorting/editSortingStandard',
		data,
		method: 'post',
	})
};

// 标记、取消标记缺货
export const editSortingLackStatus = (data) => {
	return axios.request({
		url: '/api/v1/sorting/editSortingLackStatus',
		data,
		method: 'post',
	})
};

// 查询所有sku数据
export const queryAllSkus = (data) => {
	return axios.request({
		url: '/api/v1/sorting/queryAllSkus',
		params: data,
		method: 'get',
	})
};

// 按订单分拣
export const querySortingByOrder = (data) => {
	return axios.request({
		url: '/api/v1/sorting/querySortingByOrder',
		params: data,
		method: 'get',
	})
};

// 按订单分拣明细
export const querySortingListByOrder = (data) => {
	return axios.request({
		url: '/api/v1/sorting/querySortingListByOrder',
		params: data,
		method: 'get',
	})
};

/**
 * 查询打印模板
 */
export const queryPrintTemplateList = (data) => {
	return axios.request({
		url: '/api/v1/comm/queryPrintTemplateList',
		data,
		method: 'post'
	})
};

/**
 * 查询打印模板
 */
export const getPrintTemplate = (data) => {
	return axios.request({
		url: '/api/v1/comm/getPrintTemplate',
		data,
		method: 'post'
	})
};

/**
 * 查询SKU分类
 */
export const querySkuCategory = (data) => {
	return axios.request({
		url: '/api/v1/comm/querySkuCategory',
		params: data,
		method: 'get'
	})
};

/**
 * 查询单个数据
 */
export const getSortingDataById = (data) => {
	return axios.request({
		url: '/api/v1/sorting/getSortingDataById',
		params: data,
		method: 'get'
	})
};

/**
 * 生成分拣序号
 */
export const initSortingNo = (data) => {
	return axios.request({
		url: '/api/v1/sorting/initSortingNo',
		params: data,
		method: 'get'
	})
};



// WEBPACK FOOTER //
// ./src/api/sorting/sorting.js